import React, { useMemo, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import {

    ArrowLeft,

    Plus,

    Search,

    Eye,

    Pencil,

    Trash2,

    ChevronLeft,

    ChevronRight,

    X,

    CheckCircle,

    AlertTriangle,

    Database,

} from "lucide-react";



import masterConfig from "../../config/masterConfig";



const initialData = {

    state: [

        {

            id: 1,

            name: "Tamil Nadu",

            code: "TN",

            status: "Active",

        },

        {

            id: 2,

            name: "Kerala",

            code: "KL",

            status: "Active",

        },

        {

            id: 3,

            name: "Karnataka",

            code: "KA",

            status: "Active",

        },

        {

            id: 4,

            name: "Andhra Pradesh",

            code: "AP",

            status: "Active",

        },

        {

            id: 5,

            name: "Telangana",

            code: "TS",

            status: "Inactive",

        },

    ],



    district: [

        {

            id: 1,

            name: "Erode",

            state: "Tamil Nadu",

            status: "Active",

        },

        {

            id: 2,

            name: "Coimbatore",

            state: "Tamil Nadu",

            status: "Active",

        },

        {

            id: 3,

            name: "Salem",

            state: "Tamil Nadu",

            status: "Active",

        },

        {

            id: 4,

            name: "Tiruppur",

            state: "Tamil Nadu",

            status: "Active",

        },

        {

            id: 5,

            name: "Namakkal",

            state: "Tamil Nadu",

            status: "Inactive",

        },

    ],



    community: [

        {

            id: 1,

            name: "Community 1",

            description: "Community description",

            status: "Active",

        },

        {

            id: 2,

            name: "Community 2",

            description: "Community description",

            status: "Active",

        },

        {

            id: 3,

            name: "Community 3",

            description: "Community description",

            status: "Inactive",

        },

    ],



    education: [

        {

            id: 1,

            name: "B.E / B.Tech",

            category: "Under Graduate",

            status: "Active",

        },

        {

            id: 2,

            name: "M.E / M.Tech",

            category: "Post Graduate",

            status: "Active",

        },

        {

            id: 3,

            name: "MBA",

            category: "Post Graduate",

            status: "Active",

        },

        {

            id: 4,

            name: "MBBS",

            category: "Professional",

            status: "Active",

        },

    ],



    profession: [

        {

            id: 1,

            name: "Software Engineer",

            category: "IT",

            status: "Active",

        },

        {

            id: 2,

            name: "Doctor",

            category: "Medical",

            status: "Active",

        },

        {

            id: 3,

            name: "Teacher",

            category: "Education",

            status: "Active",

        },

        {

            id: 4,

            name: "Business",

            category: "Business",

            status: "Inactive",

        },

    ],



    caste: [

        {

            id: 1,

            name: "Caste 1",

            community: "Community 1",

            subCommunity: "Sub Community 1",

            status: "Active",

        },

        {

            id: 2,

            name: "Caste 2",

            community: "Community 1",

            subCommunity: "Sub Community 2",

            status: "Active",

        },

        {

            id: 3,

            name: "Caste 3",

            community: "Community 2",

            subCommunity: "Sub Community 1",

            status: "Inactive",

        },

    ],



    religion: [

        {

            id: 1,

            name: "Hindu",

            status: "Active",

        },

        {

            id: 2,

            name: "Christian",

            status: "Active",

        },

        {

            id: 3,

            name: "Muslim",

            status: "Active",

        },

    ],



    "mother-tongue": [

        {

            id: 1,

            name: "Tamil",

            status: "Active",

        },

        {

            id: 2,

            name: "English",

            status: "Active",

        },

        {

            id: 3,

            name: "Malayalam",

            status: "Active",

        },

    ],



    occupation: [

        {

            id: 1,

            name: "Private Employee",

            status: "Active",

        },

        {

            id: 2,

            name: "Government Employee",

            status: "Active",

        },

        {

            id: 3,

            name: "Business",

            status: "Active",

        },

    ],



    income: [

        {

            id: 1,

            name: "Below ₹3 Lakhs",

            min: "0",

            max: "300000",

            status: "Active",

        },

        {

            id: 2,

            name: "₹3 - ₹5 Lakhs",

            min: "300000",

            max: "500000",

            status: "Active",

        },

        {

            id: 3,

            name: "₹5 - ₹10 Lakhs",

            min: "500000",

            max: "1000000",

            status: "Active",

        },

    ],



    "marital-status": [

        {

            id: 1,

            name: "Never Married",

            status: "Active",

        },

        {

            id: 2,

            name: "Divorced",

            status: "Active",

        },

        {

            id: 3,

            name: "Widowed",

            status: "Active",

        },

    ],



    "family-type": [

        {

            id: 1,

            name: "Joint Family",

            status: "Active",

        },

        {

            id: 2,

            name: "Nuclear Family",

            status: "Active",

        },

    ],



    "family-status": [

        {

            id: 1,

            name: "Middle Class",

            status: "Active",

        },

        {

            id: 2,

            name: "Upper Middle Class",

            status: "Active",

        },

        {

            id: 3,

            name: "Affluent",

            status: "Active",

        },

    ],



    star: [

        {

            id: 1,

            name: "Ashwini",

            tamilName: "அசுவினி",

            status: "Active",

        },

        {

            id: 2,

            name: "Bharani",

            tamilName: "பரணி",

            status: "Active",

        },

        {

            id: 3,

            name: "Krittika",

            tamilName: "கார்த்திகை",

            status: "Active",

        },

    ],



    rasi: [

        {

            id: 1,

            name: "Mesha",

            tamilName: "மேஷம்",

            status: "Active",

        },

        {

            id: 2,

            name: "Rishabha",

            tamilName: "ரிஷபம்",

            status: "Active",

        },

        {

            id: 3,

            name: "Mithuna",

            tamilName: "மிதுனம்",

            status: "Active",

        },

    ],



    dosham: [

        {

            id: 1,

            name: "Sevvai Dosham",

            status: "Active",

        },

        {

            id: 2,

            name: "Rahu Dosham",

            status: "Active",

        },

        {

            id: 3,

            name: "Kethu Dosham",

            status: "Active",

        },

        {

            id: 4,

            name: "No Dosham",

            status: "Active",

        },

    ],



    height: [

        {

            id: 1,

            name: "Below 5 Feet",

            status: "Active",

        },

        {

            id: 2,

            name: "5 - 5.5 Feet",

            status: "Active",

        },

        {

            id: 3,

            name: "5.5 - 6 Feet",

            status: "Active",

        },

    ],



    "body-type": [

        {

            id: 1,

            name: "Slim",

            status: "Active",

        },

        {

            id: 2,

            name: "Average",

            status: "Active",

        },

        {

            id: 3,

            name: "Athletic",

            status: "Active",

        },

    ],



    complexion: [

        {

            id: 1,

            name: "Very Fair",

            status: "Active",

        },

        {

            id: 2,

            name: "Fair",

            status: "Active",

        },

        {

            id: 3,

            name: "Wheatish",

            status: "Active",

        },

        {

            id: 4,

            name: "Dusky",

            status: "Active",

        },

    ],



    "blood-group": [

        {

            id: 1,

            name: "A+",

            status: "Active",

        },

        {

            id: 2,

            name: "A-",

            status: "Active",

        },

        {

            id: 3,

            name: "B+",

            status: "Active",

        },

        {

            id: 4,

            name: "B-",

            status: "Active",

        },

        {

            id: 5,

            name: "O+",

            status: "Active",

        },

        {

            id: 6,

            name: "O-",

            status: "Active",

        },

        {

            id: 7,

            name: "AB+",

            status: "Active",

        },

        {

            id: 8,

            name: "AB-",

            status: "Active",

        },

    ],



    country: [

        {

            id: 1,

            name: "India",

            code: "IN",

            status: "Active",

        },

        {

            id: 2,

            name: "United States",

            code: "US",

            status: "Active",

        },

        {

            id: 3,

            name: "United Kingdom",

            code: "GB",

            status: "Active",

        },

    ],



    city: [

        {

            id: 1,

            name: "Erode",

            district: "Erode",

            state: "Tamil Nadu",

            status: "Active",

        },

        {

            id: 2,

            name: "Coimbatore",

            district: "Coimbatore",

            state: "Tamil Nadu",

            status: "Active",

        },

        {

            id: 3,

            name: "Salem",

            district: "Salem",

            state: "Tamil Nadu",

            status: "Active",

        },

    ],



    "branch-staff": [

        {

            id: 1,

            name: "Karthik",

            branch: "Erode Main Branch",

            mobile: "9876543210",

            status: "Active",

        },

        {

            id: 2,

            name: "Priya",

            branch: "Coimbatore Branch",

            mobile: "9876543211",

            status: "Active",

        },

        {

            id: 3,

            name: "Suresh",

            branch: "Salem Branch",

            mobile: "9876543212",

            status: "Inactive",

        },

    ],

};



function MasterList() {

    const { masterType } = useParams();

    const navigate = useNavigate();



    const config = masterConfig[masterType];



    const [data, setData] = useState(

        initialData[masterType] || []

    );



    const [search, setSearch] = useState("");

    const [statusFilter, setStatusFilter] = useState("All");



    const [showForm, setShowForm] = useState(false);

    const [formMode, setFormMode] = useState("add");

    const [selectedItem, setSelectedItem] = useState(null);



    const [showView, setShowView] = useState(false);

    const [showDelete, setShowDelete] = useState(false);



    const [formData, setFormData] = useState({});



    const [currentPage, setCurrentPage] = useState(1);



    const itemsPerPage = 8;

    const filteredData = useMemo(() => {

        const keyword = search.trim().toLowerCase();



        return data.filter((item) => {

            const matchesSearch =

                !keyword ||

                Object.values(item).some((value) =>

                    String(value)

                        .toLowerCase()

                        .includes(keyword)

                );



            const matchesStatus =

                statusFilter === "All" ||

                item.status === statusFilter;



            return matchesSearch && matchesStatus;

        });

    }, [data, search, statusFilter]);




     if (!config) {

        return (

            <div className="master-not-found">

                <Database size={40} />



                <h2>Master Not Found</h2>



                <p>

                    The requested master configuration does not

                    exist.

                </p>



                <button

                    onClick={() =>

                        navigate("/super-admin/masters")

                    }

                >

                    Back to Masters

                </button>

            </div>

        );

    }




    const totalPages = Math.ceil(

        filteredData.length / itemsPerPage

    );



    const paginatedData = filteredData.slice(

        (currentPage - 1) * itemsPerPage,

        currentPage * itemsPerPage

    );



    const activeCount = data.filter(

        (item) => item.status === "Active"

    ).length;



    const inactiveCount = data.filter(

        (item) => item.status === "Inactive"

    ).length;



    const resetForm = () => {

        const values = {};



        config.fields.forEach((field) => {

            values[field.name] = "";

        });



        setFormData(values);

    };



    const openAdd = () => {

        resetForm();

        setFormMode("add");

        setSelectedItem(null);

        setShowForm(true);

    };



    const openEdit = (item) => {

        const values = {};



        config.fields.forEach((field) => {

            values[field.name] = item[field.name] || "";

        });



        setFormData(values);

        setSelectedItem(item);

        setFormMode("edit");

        setShowForm(true);

    };



    const openView = (item) => {

        setSelectedItem(item);

        setShowView(true);

    };



    const openDelete = (item) => {

        setSelectedItem(item);

        setShowDelete(true);

    };



    const handleFormChange = (name, value) => {

        setFormData((prev) => ({

            ...prev,

            [name]: value,

        }));

    };



    const handleSubmit = (e) => {

        e.preventDefault();



        for (const field of config.fields) {

            if (

                field.required &&

                !String(formData[field.name] || "").trim()

            ) {

                alert(`${field.label} is required.`);

                return;

            }

        }



        if (formMode === "add") {

            const newItem = {

                id:

                    data.length > 0

                        ? Math.max(

                              ...data.map((item) => item.id)

                          ) + 1

                        : 1,

                ...formData,

                status: "Active",

            };



            setData((prev) => [newItem, ...prev]);

        } else {

            setData((prev) =>

                prev.map((item) =>

                    item.id === selectedItem.id

                        ? {

                              ...item,

                              ...formData,

                          }

                        : item

                )

            );

        }



        setShowForm(false);

        setSelectedItem(null);

        resetForm();

        setCurrentPage(1);

    };



    const toggleStatus = (item) => {

        setData((prev) =>

            prev.map((row) =>

                row.id === item.id

                    ? {

                          ...row,

                          status:

                              row.status === "Active"

                                  ? "Inactive"

                                  : "Active",

                      }

                    : row

            )

        );

    };



    const confirmDelete = () => {

        if (!selectedItem) return;



        setData((prev) =>

            prev.filter(

                (item) => item.id !== selectedItem.id

            )

        );



        setShowDelete(false);

        setSelectedItem(null);



        if (

            paginatedData.length === 1 &&

            currentPage > 1

        ) {

            setCurrentPage(currentPage - 1);

        }

    };



    return (

        <div className="master-list-page">



            {/* HEADER */}

            <div className="master-list-header">



                <div className="master-list-heading">



                    <button

                        className="back-master-btn"

                        onClick={() =>

                            navigate("/super-admin/masters")

                        }

                    >

                        <ArrowLeft size={17} />

                    </button>



                    <div>

                        <h1>{config.title}</h1>

                        <p>{config.description}</p>

                    </div>



                </div>



                <button

                    className="master-add-btn"

                    onClick={openAdd}

                >

                    <Plus size={17} />

                    Add {config.singular}

                </button>



            </div>



            {/* SUMMARY */}

            <div className="master-list-summary">



                <div className="master-list-summary-card">

                    <div className="master-list-summary-icon blue">

                        <Database size={20} />

                    </div>



                    <div>

                        <strong>{data.length}</strong>

                        <span>Total</span>

                    </div>

                </div>



                <div className="master-list-summary-card">

                    <div className="master-list-summary-icon green">

                        <CheckCircle size={20} />

                    </div>



                    <div>

                        <strong>{activeCount}</strong>

                        <span>Active</span>

                    </div>

                </div>



                <div className="master-list-summary-card">

                    <div className="master-list-summary-icon red">

                        <X size={20} />

                    </div>



                    <div>

                        <strong>{inactiveCount}</strong>

                        <span>Inactive</span>

                    </div>

                </div>



            </div>



            {/* TOOLBAR */}

            <div className="master-list-toolbar">



                <div className="master-search">



                    <Search size={16} />



                    <input

                        type="text"

                        placeholder={`Search ${config.title.toLowerCase()}...`}

                        value={search}

                        onChange={(e) => {

                            setSearch(e.target.value);

                            setCurrentPage(1);

                        }}

                    />



                </div>



                <select

                    className="master-status-filter"

                    value={statusFilter}

                    onChange={(e) => {

                        setStatusFilter(e.target.value);

                        setCurrentPage(1);

                    }}

                >

                    <option value="All">

                        All Status

                    </option>



                    <option value="Active">

                        Active

                    </option>



                    <option value="Inactive">

                        Inactive

                    </option>

                </select>



            </div>



            {/* TABLE */}

            <div className="master-table-card">



                <div className="master-table-wrapper">



                    <table className="master-table">



                        <thead>

                            <tr>



                                <th>S.No</th>



                                {config.columns.map((column) => (

                                    <th key={column.key}>

                                        {column.label}

                                    </th>

                                ))}



                                <th>Status</th>

                                <th>Action</th>



                            </tr>

                        </thead>



                        <tbody>



                            {paginatedData.length === 0 ? (

                                <tr>

                                    <td

                                        colSpan={

                                            config.columns.length +

                                            3

                                        }

                                    >

                                        <div className="master-no-data">

                                            <Database

                                                size={30}

                                            />

                                            <strong>

                                                No records found

                                            </strong>

                                            <span>

                                                Try changing your

                                                search or filter.

                                            </span>

                                        </div>

                                    </td>

                                </tr>

                            ) : (

                                paginatedData.map(

                                    (item, index) => (

                                        <tr key={item.id}>



                                            <td>

                                                {(currentPage -

                                                    1) *

                                                    itemsPerPage +

                                                    index +

                                                    1}

                                            </td>



                                            {config.columns.map(

                                                (column) => (

                                                    <td

                                                        key={

                                                            column.key

                                                        }

                                                    >

                                                        {item[

                                                            column.key

                                                        ] ||

                                                            "-"}

                                                    </td>

                                                )

                                            )}



                                            <td>

                                                <button

                                                    className={`master-status-btn ${

                                                        item.status ===

                                                        "Active"

                                                            ? "active"

                                                            : "inactive"

                                                    }`}

                                                    onClick={() =>

                                                        toggleStatus(

                                                            item

                                                        )

                                                    }

                                                >

                                                    {item.status}

                                                </button>

                                            </td>



                                            <td>



                                                <div className="master-actions">



                                                    <button

                                                        className="master-action view"

                                                        title="View"

                                                        onClick={() =>

                                                            openView(

                                                                item

                                                            )

                                                        }

                                                    >

                                                        <Eye

                                                            size={

                                                                15

                                                            }

                                                        />

                                                    </button>



                                                    <button

                                                        className="master-action edit"

                                                        title="Edit"

                                                        onClick={() =>

                                                            openEdit(

                                                                item

                                                            )

                                                        }

                                                    >

                                                        <Pencil

                                                            size={

                                                                15

                                                            }

                                                        />

                                                    </button>



                                                    <button

                                                        className="master-action delete"

                                                        title="Delete"

                                                        onClick={() =>

                                                            openDelete(

                                                                item

                                                            )

                                                        }

                                                    >

                                                        <Trash2

                                                            size={

                                                                15

                                                            }

                                                        />

                                                    </button>



                                                </div>



                                            </td>



                                        </tr>

                                    )

                                )

                            )}



                        </tbody>



                    </table>



                </div>



                {/* PAGINATION */}

                {totalPages > 0 && (

                    <div className="master-pagination">



                        <span>

                            Showing{" "}

                            <strong>

                                {Math.min(

                                    (currentPage - 1) *

                                        itemsPerPage +

                                        1,

                                    filteredData.length

                                )}

                            </strong>{" "}

                            to{" "}

                            <strong>

                                {Math.min(

                                    currentPage *

                                        itemsPerPage,

                                    filteredData.length

                                )}

                            </strong>{" "}

                            of{" "}

                            <strong>

                                {filteredData.length}

                            </strong>{" "}

                            records

                        </span>



                        <div className="pagination-buttons">



                            <button

                                disabled={currentPage === 1}

                                onClick={() =>

                                    setCurrentPage(

                                        (page) =>

                                            page - 1

                                    )

                                }

                            >

                                <ChevronLeft size={15} />

                            </button>



                            {Array.from(

                                {

                                    length: totalPages,

                                },

                                (_, index) => index + 1

                            ).map((page) => (

                                <button

                                    key={page}

                                    className={

                                        currentPage ===

                                        page

                                            ? "active"

                                            : ""

                                    }

                                    onClick={() =>

                                        setCurrentPage(

                                            page

                                        )

                                    }

                                >

                                    {page}

                                </button>

                            ))}



                            <button

                                disabled={

                                    currentPage ===

                                    totalPages

                                }

                                onClick={() =>

                                    setCurrentPage(

                                        (page) =>

                                            page + 1

                                    )

                                }

                            >

                                <ChevronRight size={15} />

                            </button>



                        </div>



                    </div>

                )}



            </div>



            {/* ADD / EDIT MODAL */}

            {showForm && (

                <div className="master-modal-overlay">



                    <div className="master-modal">



                        <div className="master-modal-header">



                            <div>

                                <h2>

                                    {formMode === "add"

                                        ? `Add ${config.singular}`

                                        : `Edit ${config.singular}`}

                                </h2>



                                <p>

                                    Enter the required

                                    information below.

                                </p>

                            </div>



                            <button

                                className="modal-close-btn"

                                onClick={() =>

                                    setShowForm(false)

                                }

                            >

                                <X size={18} />

                            </button>



                        </div>



                        <form

                            onSubmit={handleSubmit}

                            className="master-form"

                        >



                            <div className="master-form-grid">



                                {config.fields.map(

                                    (field) => (

                                        <div

                                            className={`master-form-group ${

                                                field.type ===

                                                    "textarea"

                                                    ? "full"

                                                    : ""

                                            }`}

                                            key={

                                                field.name

                                            }

                                        >



                                            <label>

                                                {

                                                    field.label

                                                }



                                                {field.required && (

                                                    <span>

                                                        *

                                                    </span>

                                                )}

                                            </label>



                                            {field.type ===

                                            "select" ? (

                                                <select

                                                    value={

                                                        formData[

                                                            field

                                                                .name

                                                        ] ||

                                                        ""

                                                    }

                                                    onChange={(

                                                        e

                                                    ) =>

                                                        handleFormChange(

                                                            field.name,

                                                            e

                                                                .target

                                                                .value

                                                        )

                                                    }

                                                >

                                                    <option value="">

                                                        Select{" "}

                                                        {

                                                            field.label

                                                        }

                                                    </option>



                                                    {field.options?.map(

                                                        (

                                                            option

                                                        ) => (

                                                            <option

                                                                key={

                                                                    option

                                                                }

                                                                value={

                                                                    option

                                                                }

                                                            >

                                                                {

                                                                    option

                                                                }

                                                            </option>

                                                        )

                                                    )}

                                                </select>

                                            ) : field.type ===

                                              "textarea" ? (

                                                <textarea

                                                    rows="4"

                                                    value={

                                                        formData[

                                                            field

                                                                .name

                                                        ] ||

                                                        ""

                                                    }

                                                    onChange={(

                                                        e

                                                    ) =>

                                                        handleFormChange(

                                                            field.name,

                                                            e

                                                                .target

                                                                .value

                                                        )

                                                    }

                                                />

                                            ) : (

                                                <input

                                                    type={

                                                        field.type ||

                                                        "text"

                                                    }

                                                    value={

                                                        formData[

                                                            field

                                                                .name

                                                        ] ||

                                                        ""

                                                    }

                                                    onChange={(

                                                        e

                                                    ) =>

                                                        handleFormChange(

                                                            field.name,

                                                            e

                                                                .target

                                                                .value

                                                        )

                                                    }

                                                    placeholder={`Enter ${field.label}`}

                                                />

                                            )}



                                        </div>

                                    )

                                )}



                            </div>



                            <div className="master-modal-footer">



                                <button

                                    type="button"

                                    className="modal-cancel-btn"

                                    onClick={() =>

                                        setShowForm(false)

                                    }

                                >

                                    Cancel

                                </button>



                                <button

                                    type="submit"

                                    className="modal-save-btn"

                                >

                                    <CheckCircle

                                        size={15}

                                    />



                                    {formMode === "add"

                                        ? "Add"

                                        : "Update"}

                                </button>



                            </div>



                        </form>



                    </div>



                </div>

            )}



            {/* VIEW MODAL */}

            {showView && selectedItem && (

                <div className="master-modal-overlay">



                    <div className="master-modal view-modal">



                        <div className="master-modal-header">



                            <div>

                                <h2>

                                    {config.singular} Details

                                </h2>



                                <p>

                                    View master information.

                                </p>

                            </div>



                            <button

                                className="modal-close-btn"

                                onClick={() =>

                                    setShowView(false)

                                }

                            >

                                <X size={18} />

                            </button>



                        </div>



                        <div className="master-view-grid">



                            {config.columns.map(

                                (column) => (

                                    <div

                                        className="master-view-item"

                                        key={column.key}

                                    >

                                        <span>

                                            {

                                                column.label

                                            }

                                        </span>



                                        <strong>

                                            {selectedItem[

                                                column.key

                                            ] || "-"}

                                        </strong>

                                    </div>

                                )

                            )}



                            <div className="master-view-item">

                                <span>Status</span>



                                <strong>

                                    <span

                                        className={`master-view-status ${

                                            selectedItem.status ===

                                            "Active"

                                                ? "active"

                                                : "inactive"

                                        }`}

                                    >

                                        {

                                            selectedItem.status

                                        }

                                    </span>

                                </strong>

                            </div>



                        </div>



                        <div className="master-modal-footer">



                            <button

                                className="modal-cancel-btn"

                                onClick={() =>

                                    setShowView(false)

                                }

                            >

                                Close

                            </button>



                            <button

                                className="modal-save-btn"

                                onClick={() => {

                                    setShowView(false);

                                    openEdit(

                                        selectedItem

                                    );

                                }}

                            >

                                <Pencil size={15} />

                                Edit

                            </button>



                        </div>



                    </div>



                </div>

            )}



            {/* DELETE MODAL */}

            {showDelete && selectedItem && (

                <div className="master-modal-overlay">



                    <div className="master-delete-modal">



                        <div className="delete-icon">

                            <AlertTriangle size={25} />

                        </div>



                        <h2>

                            Delete {config.singular}?

                        </h2>



                        <p>

                            Are you sure you want to delete

                            <strong>

                                {" "}

                                {selectedItem.name}

                            </strong>

                            ? This action cannot be undone.

                        </p>



                        <div className="delete-actions">



                            <button

                                className="modal-cancel-btn"

                                onClick={() =>

                                    setShowDelete(false)

                                }

                            >

                                Cancel

                            </button>



                            <button

                                className="delete-confirm-btn"

                                onClick={confirmDelete}

                            >

                                <Trash2 size={15} />

                                Delete

                            </button>



                        </div>



                    </div>



                </div>

            )}



        </div>

    );

}



export default MasterList;
